var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.align},[_vm._l((_vm.pages),function(page){return _c('router-link',{key:page.uid,staticClass:"link",attrs:{"to":_vm.path(page.url)},domProps:{"innerHTML":_vm._s(page.strings.title)}})}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }